module.exports = __webpack_public_path__ + "img/noResult.6db92f62.png";